module.exports = __webpack_public_path__ + "res/img/cursor.eb362d10.png";